<script>
import PROOF_EVENTS from "../../utils/proofEvents";
import { getAppEventProperty } from "../../utils/helpers";

const {
  ProofCreated,
  ProofSent,
  ProofApprovedWithChanges,
  ProofApproved,
  ProofNotApproved,
  ProofNoteEvent,
  EmailSent,
  AccountAlertEvent,
  AnnotationCommentThreadUpdated,
  ProofFileUploadedEvent,
  ProofFileDeletedEvent,
  ProofVersionHiddenEvent,
  ProofVersionRevealedEvent,
  WorkflowProofStageStarted,
} = PROOF_EVENTS;

export default {
  name: "activity-feed",
  props: {
    events: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loaded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      EmailSent,
      AccountAlertEvent,
    };
  },
  methods: {
    getIconFromStatus(event) {
      let proofEventType = event.eventType;
      let approverStatusTaken = _.get(event, "appEventObject.statusTaken", 0);
      if ([ProofNoteEvent].indexOf(proofEventType) !== -1) {
        return "/img/pencil-timeline-icon.svg";
      } else if ([EmailSent, ProofSent].indexOf(proofEventType) !== -1) {
        return "/img/email-sent-timeline-icon.svg";
      } else if ([ProofNotApproved].indexOf(proofEventType) !== -1 || approverStatusTaken === 3) {
        return "/img/not-approved-timeline-icon.svg";
      } else if (proofEventType === ProofFileUploadedEvent) {
        return "/img/added-version-file.svg";
      } else if (proofEventType === ProofFileDeletedEvent) {
        return "/img/delete-version-file.svg";
      } else if (proofEventType === WorkflowProofStageStarted) {
        return "/img/stage-change-timeline-icon.svg";
      } else if (proofEventType === ProofVersionHiddenEvent) {
        return "/img/hidden-version-file.svg";
      } else if (proofEventType === ProofVersionRevealedEvent) {
        return "/img/updated-version-to-visible.svg";
      } else if (
        [ProofApprovedWithChanges, ProofApproved].indexOf(proofEventType) !== -1 ||
        approverStatusTaken > 3
      ) {
        return "/img/approved-timeline-icon.svg";
      } else if (proofEventType === ProofCreated) {
        return "/img/create-proof-timeline-icon.svg";
      } else if (proofEventType === AnnotationCommentThreadUpdated && event.appEventObject.commentAnnotation) {
        return "/img/comments-timeline-icon.svg";
      } else {
        return "img/view-timeline-icon.svg";
      }
    },
    getPostMarkResponse(event) {
      return (
        getAppEventProperty(event, "additionalData.postMarkResponse", "") ||
        getAppEventProperty(event, "postMarkResponse", "")
      );
    },
    isEmpty(arr) {
      return _.isEmpty(arr);
    },
  },
};
</script>

<template>
  <div class="activity-card" :class="{ 'is-loading': loading }">
    <div class="card-head">Recent Activity</div>
    <div class="activity-scroll">
      <div v-for="(event, index) in events" :key="index" class="activity-row">
        <img :src="getIconFromStatus(event)" class="activity-icon" alt="" />
        <div class="activity-content">
          <div class="activity-proof-name" v-if="event.proofName">{{ event.proofName }}</div>
          <div class="activity-description">
            {{ event.eventType === AccountAlertEvent && event.appEventObject ? getPostMarkResponse(event) : event.description }}
          </div>
          <div class="activity-date">
            {{ $A.FormatDateToString(event.createdAt, true) }} at {{ $A.FormatDateToTime(event.createdAt) }}
          </div>
        </div>
        <div class="activity-actions">
          <button
            v-if="event.eventType === EmailSent"
            type="button"
            class="activity-view-btn"
            @click="$emit('view-email', event.emailLogId)"
          >View</button>
          <button
            v-if="event.proofId > 0"
            type="button"
            class="activity-view-btn"
            @click="$emit('view-proof', event.proofId)"
          >View</button>
          <button
            v-if="!event.proofId && event.eventType !== EmailSent && event.approverId > 0"
            type="button"
            class="activity-view-btn"
            @click="$emit('view-approver', event.approverId)"
          >View</button>
        </div>
      </div>
      <div v-if="loaded && isEmpty(events)" class="activity-empty">
        <img src="/img/no-activity.gif" class="activity-empty-gif" alt="" />
        <span class="activity-empty-title">Check back later!</span>
        <span class="activity-empty-text">No activity in this period</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.activity-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 520px;
  transition: opacity 150ms ease;
}
.activity-card.is-loading {
  opacity: 0.45;
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  flex-shrink: 0;
}
.activity-scroll {
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.activity-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  flex-shrink: 0;
}
@media (max-width: 575px) {
  .activity-row {
    padding: 12px;
    gap: 10px;
  }
  .activity-icon {
    width: 26px;
    height: 26px;
  }
}
.activity-row:last-child {
  border-bottom: 0;
}
.activity-icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}
.activity-content {
  flex: 1;
  min-width: 0;
}
.activity-proof-name {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}
.activity-description {
  font-size: 12.5px;
  font-weight: 400;
  color: #4b5563;
  line-height: 1.45;
}
.activity-date {
  margin-top: 2px;
  font-size: 11px;
  font-weight: 500;
  color: #9ca3af;
}
.activity-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.activity-view-btn {
  background: transparent;
  border: 0;
  padding: 2px 6px;
  font-size: 12.5px;
  font-weight: 600;
  color: #019256;
  cursor: pointer;
  border-radius: 6px;
}
.activity-view-btn:hover {
  color: #017a48;
  background: rgba(1, 146, 86, 0.06);
}
.activity-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 280px;
  padding: 32px 16px;
  text-align: center;
}
.activity-empty-gif {
  max-width: 220px;
}
.activity-empty-title {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}
.activity-empty-text {
  font-size: 12.5px;
  font-weight: 500;
  color: #6b7280;
}
</style>
